import { apiClient } from '@/shared/lib/apiClient';
import type { ApiResponse, Notification, PaginatedResponse } from '@/types';
import { NotificationStatus } from '@/types';

export const notificationsApi = {
  async list(params?: { page?: number; limit?: number; status?: NotificationStatus }) {
    const response = await apiClient.get<PaginatedResponse<Notification>>('/notifications', {
      params,
    });
    return response.data;
  },

  async getUnreadCount() {
    const response = await apiClient.get<ApiResponse<{ count: number }>>(
      '/notifications/unread-count'
    );
    return response.data.data!.count;
  },

  async markRead(id: string) {
    const response = await apiClient.patch<ApiResponse<Notification>>(
      `/notifications/${id}/status`,
      { status: NotificationStatus.READ }
    );
    return response.data.data!;
  },

  async markAllRead() {
    await apiClient.patch('/notifications/read-all');
  },
};

export const notificationKeys = {
  all: ['notifications'] as const,
  list: (params?: { page?: number; status?: NotificationStatus }) =>
    [...notificationKeys.all, 'list', params] as const,
  unreadCount: () => [...notificationKeys.all, 'unread-count'] as const,
};
